import { Button } from '@/components/interactive/Button';
import { Reveal } from '@/components/utils/RevealOnScroll';
import { AtomicMark } from '@/components/visuals/AtomicMark';

interface ClosingCTAProps {
  h2: string;
  body?: string;
  primary?: { label: string; href: string };
  secondary?: { label: string; href: string };
}

export function ClosingCTA({
  h2,
  body,
  primary = { label: 'Contact us', href: '/contact' },
  secondary,
}: ClosingCTAProps) {
  return (
    <section
      className="section-loose"
      style={{
        position: 'relative',
        borderTop: '1px solid var(--border-subtle)',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          height: 800,
          background:
            'radial-gradient(circle, var(--radium-glow) 0%, transparent 60%)',
          pointerEvents: 'none',
          opacity: 0.7,
        }}
      />
      <div
        className="container"
        style={{ position: 'relative', textAlign: 'center' }}
      >
        <div
          className="glass glass--settled"
          style={{
            maxWidth: 920,
            margin: '0 auto',
            padding: '48px 40px 52px',
            borderRadius: 20,
          }}
        >
          <Reveal>
            <AtomicMark size={48} tone="var(--accent)" />
          </Reveal>
          <Reveal delay={100}>
            <h2
              className="text-h1"
              style={{
                marginTop: 32,
                maxWidth: 800,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              {h2}
            </h2>
          </Reveal>
          {body && (
            <Reveal delay={200}>
              <p
                className="text-body-lg"
                style={{ marginTop: 24, maxWidth: 600, margin: '24px auto 0' }}
              >
                {body}
              </p>
            </Reveal>
          )}
          <Reveal delay={320}>
            <div
              style={{
                marginTop: 40,
                display: 'flex',
                gap: 16,
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <Button href={primary.href} variant="primary" size="lg" chevron>
                {primary.label}
              </Button>
              {secondary && (
                <Button href={secondary.href} variant="secondary" size="lg">
                  {secondary.label}
                </Button>
              )}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
